export default __webpack_public_path__ + "static/media/presentation.144fe794.jpg";